
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5dbde556&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProfitLoss.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProfitLoss.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-5dbde556!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProfitLoss.vue"),
  /* scopeId */
  "data-v-5dbde556",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/dashboard/ProfitLoss.vue
// module id = 650
// module chunks = 0